import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import { OrderStatus } from "../../../models/receipt/types";

// Web hailing's copy of the web receipt's status card (web-receipt/OrderStatusOverview
// with its DriverDetailsBanner), so the tracker looks like the receipt but does not
// change when the receipt does.
export interface TripStatusCardProps {
  phase: OrderStatus;
  title: string;
  subtitle: string;
  timeInfo: string;
  showDriverLocationBanner: boolean;
  isArrived: boolean;
}

const TripStatusCard: React.FC<TripStatusCardProps> = ({
  phase,
  title,
  subtitle,
  timeInfo,
  showDriverLocationBanner,
  isArrived,
}) => {
  const { t } = useTranslation("hailing");
  const isFinished = phase === "completed" || phase === "cancelled";
  return (
    <div
      className={`border-b border-gray-200 bg-white p-[16px] mb-1${
        isFinished ? "" : " rounded-t-lg"
      }`}
    >
      <div className="flex flex-row items-end w-full">
        <div className="flex flex-col justify-end flex-1 min-w-0">
          {!isFinished && subtitle && (
            <div className="text-base font-semibold text-mineshaft-900 mt-4 mb-4">
              {subtitle}
            </div>
          )}
          <div className="text-3xl font-bold leading-none mb-4 break-words">
            {title}
          </div>
          {isFinished && subtitle && (
            <div className="text-base font-semibold text-mineshaft-900 mt-2 mb-4">
              {subtitle}
            </div>
          )}
        </div>
        {timeInfo && !isArrived && (
          <div className="flex flex-col items-end justify-end min-w-[120px] ml-3 pr-4 pb-4">
            <span className="text-base font-normal text-neutral-900 whitespace-nowrap">
              {timeInfo}
            </span>
          </div>
        )}
      </div>
      {showDriverLocationBanner && (
        <div className="rounded-lg p-4 flex items-center gap-3 bg-brand-blue-light mb-2">
          <InfoIcon color="info" sx={{ fontSize: 24 }} />
          <div className="flex-1">
            <span className="text-base font-medium text-mineshaft-900 leading-tight">
              {t("steps.ride.tracker.tripScheduled_driverLocationBanner")}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TripStatusCard;
